import posed from 'react-pose';

export const FiltersPosedWrapper = posed.div({
  closed: {
    height: 0,
  },
  open: {
    height: 'auto',
  },
});
